import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'

@Component({
	selector: 'app-popover-tip',
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="popover">
			<div class="popover__content">
				<ng-content></ng-content>
			</div>
		</div>
	`,
	styles: [
		`
			:host {
				font-size: 1.6rem;
			}

			.popover {
				/* background: var(--brandAccent_s10);
				color: var(--richBlack); */
				background: var(--richBlack);
				color: var(--white);
				padding: 1.6rem 3.2rem;
				border-radius: 4px;
				box-shadow: 1px 1px 5px rgba(85, 85, 85, 0.15);
				opacity: 0.85;
				&__content {
					border-radius: 4px;
					opacity: 1;
				}
			}
		`,
	],
})
export class PopoverTipComponent {}
